<template>
  <div class="sidebar-component">
    <loading v-if="vLoading" />
    <span v-show="reactivity"></span>
    <v-app-bar
      app
      fixed
      :class="drawer ? 'header-right' : ''"
      v-if="$route.name != 'چاپ پکینگ  لیست'"
    >
      <v-app-bar-nav-icon
        v-if="role != 'مشتری'"
        class="menu-button"
        @click="toggle()"
      >
      </v-app-bar-nav-icon>

      <img src="/img/brand/big.png" alt="" class="logo" />
      <v-spacer></v-spacer>
      <b-btn
        variant="warning"
        class="me-5"
        v-if="roleType == 'کارخانه'"
        @click="logout()"
      >
        خروج از سامانه
      </b-btn>
      <div>
        <v-tooltip v-if="deviceType != 'mobile'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              @click="$router.push('/allChats')"
              class="me-4 pointer"
              style="position: relative"
            >
              <i class="fa fa-comments-o fa-2x" aria-hidden="true"></i>

              <v-badge
                v-if="unseenChats"
                color="primary"
                :content="unseenChats"
                style="
                  transform: translateY(-3px);
                  position: absolute;
                  top: 10px;
                  right: -2px;
                "
              ></v-badge>
            </div>
          </template>
          <span class="fs-xsmall">فهرست گفتمان</span>
        </v-tooltip>

        <div
          v-else
          @click="$router.push('/allChats')"
          class="me-4 pointer"
          style="position: relative"
        >
          <i class="fa fa-comments-o fa-2x" aria-hidden="true"></i>

          <v-badge
            v-if="unseenChats"
            color="primary"
            :content="unseenChats"
            style="
              transform: translateY(-3px);
              position: absolute;
              top: 10px;
              right: -2px;
            "
          ></v-badge>
        </div>
      </div>
      <v-menu offset-y bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            width="55"
            style="min-width: 50px !important"
            v-bind="attrs"
            v-on="on"
          >
            <i class="fa fa-user fa-2x" aria-hidden="true"></i>
          </v-btn>
        </template>
        <v-list class="p-2">
          <v-list-item class="text-dark" disabled
            ><b>{{ user }} عزیز</b>، خوش آمدید</v-list-item
          >
          <v-list-item disabled class="text-dark"
            ><b>نقش شما</b>: {{ role }}</v-list-item
          >
          <v-list-item v-if="role != 'مشتری'" disabled class="text-dark"
            ><b>نوع نقش شما</b>: {{ roleType }}</v-list-item
          >

          <v-list-item class="text-center" @click="logout()"
            ><i class="me-3 fa fa-sign-out text-dark" aria-hidden="true"></i>
            خروج</v-list-item
          >
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      app
      v-model="drawer"
      class="drawer"
      right
      :hide-overlay="true"
    >
      <!--style="position:fixed; top:56px; overflow-y:scroll;"-->

      <v-list class="menu-list mt-8">
        <v-list-item
          class="menu-items ps-0 pe-0 my-1"
          v-for="(item, index) in nav"
          :class="item.open && item.children ? 'menu-items-active' : ''"
          :key="index"
          route
          :to="item.url"
        >
          <v-list-item-content>
            <v-list-item-title
              @click="item.open = !item.open"
              class="item-content item-title black--text text--lighten-5 pe-3 ps-3"
            >
              <v-icon right small class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="item-name">
                {{ item.name }}
              </span>
              <v-spacer></v-spacer>

              <div
                class="notif-count ms-3"
                v-if="item.name == 'دبیرخانه' && notificationCount != '0'"
              >
                <span class="fs-xsmall pt-1">{{ notificationCount }}</span>
              </div>
              <v-icon
                v-if="item.children && !item.open"
                left
                class="down-icon sidebar-icon"
                >mdi-chevron-right</v-icon
              >
              <v-icon
                v-if="item.children && item.open"
                left
                class="down-icon sidebar-icon"
                >mdi-chevron-down</v-icon
              >
            </v-list-item-title>
            <Dropdown v-if="item.children" :list="item"></Dropdown>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          class="menu-items ps-0 pe-0 my-1 logout-item mb-15"
          @click="logout()"
        >
          <v-list-item-content>
            <v-list-item-title
              class="item-content item-title black--text text--lighten-5 ps-3 pe-3"
            >
              <v-icon right small class="sidebar-icon"> mdi-logout </v-icon>
              خروج
              <v-spacer></v-spacer>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Axios from "axios";
import nav from "@/_nav";
import Dropdown from "./Dropdown.vue";

export default {
  name: "Navbar",
  components: {
    Dropdown,
  },
  props: ["unseenChats", "notificationCount"],
  data() {
    return {
      nav: [],
      user: "",
      role: "",
      roleType: "",
      roles: {
        Manager: "مدیر",
        ceo: "مدیرعامل",
        secretary: "منشی",
        secretaryStatus: "منشی*",
        trade: "کارشناس بازرگانی",
        tradeIntern: "کارآموز بازرگانی",
        tradeHead: "کارشناس فنی",
        queryOrganizer: "بازرس سفارشات",
        accountant: "حسابدار",
        salesManager: "مدیر فروش",
        factory: "مدیر کارخانه",
        factoryTechnical: "مسئول فنی کارخانه",
        qa: "QA & DCC",
        qc: "مدیر کنترل کیفیت و آزمایشگاه",
        qcAgent: "کنترل کیفی",
        qcDocument: "سرتیفیکیت",
        factoryPacking: "مسئول پکینگ",
        production: "مدیر خط تولید",
        delivery: "دلیوری",
        coldForgingSupervisor: "سرپرست فورج سرد",
        cuttingNutSupervisor: "مهره‌تراش",
        coatingSupervisor: "داک و پوشش",
        threadingSupervisor: "سرپرست رزوه زنی",
        machiningSupervisor: "سرپرست ماشین کاری و فرزکاری",
        cncSupervisor: "سرپرست CNC",
        knittingSupervisor: "سرپرست قلاویز زنی و مهره تراشی",
        weldingSupervisor: "سرپرست جوشکاری",
        heatTreatmentSupervisor: "سرپرست عملیات حرارتی و سیاه کاری",
        hotForgingSupervisor: "سرپرست فورج گرم",
        dichromateSupervisor: "سرپرست داکرومات",
        cuttingSupervisor: "سرپرست برشکاری",
        factoryGeneral: "کارمند کارخانه",
        warehouse: "مسئول کل انبار",
        productsWarehouse: "مسئول انبار محصولات",
        materialsWarehouse: "مسئول انبار مواد اولیه",
        toolsWarehouse: "مسئول انبار ملزومات",
        shop: "مسئول فروشگاه",
        contact: "مشتری",
      },
      factoryRoles: {
        coldForgingSupervisor: "سرپرست فورج سرد",
        cuttingNutSupervisor: "مهره‌تراش",
        coatingSupervisor: "داک و پوشش",
        threadingSupervisor: "سرپرست رزوه زنی",
        machiningSupervisor: "سرپرست ماشین کاری و فرزکاری",
        cncSupervisor: "سرپرست CNC",
        knittingSupervisor: "سرپرست قلاویز زنی و مهره تراشی",
        weldingSupervisor: "سرپرست جوشکاری",
        heatTreatmentSupervisor: "سرپرست عملیات حرارتی و سیاه کاری",
        hotForgingSupervisor: "سرپرست فورج گرم",
        dichromateSupervisor: "سرپرست داکرومات",
        cuttingSupervisor: "سرپرست برشکاری",
        factoryGeneral: "کارمند کارخانه",
      },
      roleName: "",
      allowRender: false,
      dialog: false,
      drawer: false,
      deviceType: "",
      reactivity: false,
    };
  },

  methods: {
    toggle() {
      this.drawer = !this.drawer;
    },

    logout() {
      window.localStorage.clear();
      window.location.replace("/");
    },
  },
  mounted() {
    document.getElementById("container").scroll({
      top: 0,
      left: 0,
    });
    this.roleName = window.localStorage.getItem("role");

    this.user = window.localStorage.name;
    this.nav = nav[this.roleName];
    try {
      if (this.roles[this.roleName]) {
        this.role = this.roles[this.roleName];
        if (this.factoryRoles[this.roleName]) this.roleType = "کارخانه";
        else this.roleType = "اداری";
      } else {
        this.role = "تعریف نشده";
      }
    } catch (error) {
      this.role = "تعریف نشده";
    }

    if (window.screen.width < 1024) {
      this.deviceType = "mobile";
    } else {
      this.deviceType = "desktop";
    }

    if (this.deviceType == "mobile" || this.role == "مشتری") {
      this.drawer = false;
    } else if (
      this.$route.name == "پکینگ  لیست جدید" ||
      this.$route.name == "ویرایش پکینگ  لیست" ||
      this.$route.name == "چاپ پکینگ  لیست"
    ) {
      this.drawer = false;
    } else {
      this.drawer = true;
    }
    this.reactivity = !this.reactivity;
  },
  watch: {
    drawer(val, oldval) {
      this.$emit("navToggled", val);
    },
  },
};
</script>

<style>
.logo {
  width: 170px !important;
}

@media screen and (max-width: 700px) {
  .logo {
    width: 130px !important;
  }
}
</style>
